export const environment = {
  production: false,
  TITLE: 'Gruppo La Villa S.p.A.',
  API_URL: 'https://arkiweb2.homeip.net/api/v3/',
  QUESTIONARI_URL: 'https://arkiweb2.homeip.net/questionari_files/',
  API_PHOTO_URL: '',
  JAVALOGINURL:'https://arkihttps.homeip.net/',
  VERSION_NUMBER: '1.2.1y TEST',
  COMMIT_VERSION_NUMBER: '1.2.1w.015d',
  VERSION_DATE: new Date('2022-08-19'),
  IS_TEST: true
};
// arkiweb2.homeip.net